

interface IrbGpt {
  messageHtml: string,
  inputMessage: string, 
}

import { defineComponent, ref, PropType, computed, onMounted  } from "vue";
import moment from "moment";
import { Field } from "vee-validate";
import { useStore} from "vuex";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { useRoute } from "vue-router";
import KTReviewNoteModal from "@/views/pages/application/view/tabs/ReviewNoteModal.vue";


export default defineComponent({
  name: "note-section",
  components: {
    KTReviewNoteModal,
  },
  methods: {
    
  },
  props: {
    type: String,
  },
  
  setup(props) { 
    const store = useStore();
    const route = useRoute();
    const propType = ref(props.type);

    const currentIrbReviewNote = computed(() => {
      return store.getters.currentReviewNoteEdit;
    });

    const currentIrbReviewNoteType = computed(() => {
      return store.getters.currentIrbReviewNotesType?.data;
    });
    
    onMounted(() => {
      store.dispatch(Actions.GET_IRB_APPLICATION_RESEARCH, route.params.id);
      store.dispatch(Actions.GET_IRB_REVIEW_NOTE, {
        params: {
          id: route.params.id,
          type: props.type,
        },
      });
      store.dispatch(Actions.GET_IRB_REVIEW_NOTES_TYPE, {
        params: {
          id: route.params.id,
          type: props.type,
        },
      });
    });


    return {
      currentIrbReviewNoteType,
      currentIrbReviewNote,
      propType,
    };
  },
});
